import { render, staticRenderFns } from "./ad-product.vue?vue&type=template&id=4a80e894"
import script from "./ad-product.vue?vue&type=script&lang=js"
export * from "./ad-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports